import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./OpenDyslexic/OpenDyslexic-Regular.otf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./OpenDyslexic/OpenDyslexic-Italic.otf%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22./OpenDyslexic/OpenDyslexic-Bold.otf%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22variable%22:%22--font-opendyslexic%22,%22display%22:%22swap%22}],%22variableName%22:%22openDyslexic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'openDyslexic', 'openDyslexic Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
